import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import EcoLink from 'eco-design/base/eco-link';

export default function TheComp() {
    const { t } = useLang('dp3.page_v2');
    const { locale = 'us' } = useRouter(); // 添加这行
    const [videoLoad, setVideoLoad] = useState<boolean>(false);
    const [video0, setVideo0] = useState<[string, string]>(['', '']); // src, poster
    const [video1, setVideo1] = useState<[string, string]>(['', '']); // src, poster
    const [enterPlay, setEnterPlay] = useState<boolean>(false);

    const handleEnd = () => {
        setVideo1(['', '']);
        const video0El: HTMLVideoElement | null = document.querySelector('#dp3-K1 .box-video.video1');
        if (video0El) {
            video0El.currentTime = 0;
            video0El.play();
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setVideoLoad(true);
                    }
                });
            });
            observer.observe(document.getElementById('TabSwiperA')!);

            let scene1: any = null,
                scene2: any = null;

            const k1Info: HTMLDivElement | null = document.querySelector('#dp3-K1 .info');
            const winH = window.innerHeight;
            if (k1Info) {
                scene1 = AniContainer.create({
                    triggerElement: k1Info,
                    triggerHook: 1,
                    offset: winH * 0.75,
                    duration: k1Info.offsetHeight + winH * 0.15,
                    syncFromTo: [['#dp3-K1 .info', { opacity: 1 }, { opacity: 0 }, 0.1]],
                });
            }

            const k1Section: HTMLElement | null = document.querySelector('#dp3-K1');
            if (k1Section) {
                scene2 = AniContainer.create({
                    triggerElement: k1Section,
                    triggerHook: 1,
                    offset: k1Section.offsetHeight * 0.5,
                    duration: '100%',
                    onEnter: () => {
                        if (!video1[0]) {
                            setVideo1([
                                'https://websiteoss.ecoflow.com/upload/video/1735631802587/BannerA-start-h5.mp4',
                                'https://websiteoss.ecoflow.com/upload/image/1735786346121/KV.png',
                            ]);
                        }
                        setEnterPlay(true);
                    },
                    onLeave: () => {
                        setEnterPlay(false);
                    },
                });
            }
            return () => {
                scene1 && scene1.destroy();
                scene2 && scene2.destroy();
            };
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined' && videoLoad) {
            setVideo0([
                'https://websiteoss.ecoflow.com/upload/video/1735631802755/BannerA-loop-h5.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1735786346121/KV.png',
            ]);
            setVideo1([
                'https://websiteoss.ecoflow.com/upload/video/1735631802587/BannerA-start-h5.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1735786346121/KV.png',
            ]);
        }
    }, [videoLoad]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (enterPlay) {
                const video1El: HTMLVideoElement | null = document.querySelector('#dp3-K1 .box-video.video2');
                if (video1El) {
                    video1El.currentTime = 0;
                    video1El.play();
                }
            }
        }
    }, [enterPlay]);

    return (
        <>
            <section className={styles.section} id="dp3-K1">
                <div className="box">
                    {videoLoad && video0[0] && video0[1] && (
                        <video className="box-video video1" src={video0[0]} poster={video0[1]} loop muted playsInline preload="auto" />
                    )}
                    {videoLoad && video1[0] && video1[1] && (
                        <video className="box-video video2" src={video1[0]} poster={video1[1]} muted playsInline preload="auto" onEnded={handleEnd} />
                    )}
                </div>
                <div className="info">
                    <p className="info-label">{t('K1_label')}</p>
                    <p className="info-title">{t('K1_title')}</p>
                    <EcoLink className="info-link" href={`/${locale}/oasis-home-energy-management-system`}>
                        <span className="info-link-text">{t('K1_link')}</span>
                        <svg className="info-link-svg" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 21" fill="none">
                            <path
                                d="M7.5 5.68945L12.5 10.6895L7.5 15.6895"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </EcoLink>
                </div>
            </section>
        </>
    );
}
